export const Types = {
  SEARCH_QUERY_CHANGED: 'SEARCH_QUERY_CHANGED',
  RECEIVED_SEARCH_RESULTS: 'RECEIVED_SEARCH_RESULTS',
  CLEAR_SEARCH_RESULTS: 'CLEAR_SEARCH_RESULTS'
};

export const searchQueryChanged = (resourceType, searchQuery) => ({
  type: Types.SEARCH_QUERY_CHANGED,
  resourceType,
  searchQuery
});

export const receivedSearchResults = (resourceType, searchResults) => ({
  type: Types.RECEIVED_SEARCH_RESULTS,
  resourceType,
  searchResults
});

export const clearSearchResults = resourceType => ({
  type: Types.CLEAR_SEARCH_RESULTS,
  resourceType
});



// WEBPACK FOOTER //
// ./public/components/MasterSearchBar/actions.js